import React from 'react';
import { PhoneCall } from 'lucide-react';
import { HEADER_TITLE } from './config';

// Barra superior de la landing: punto dorado intermitente = "agenda abierta ahora".
// Móvil: ● [teléfono] Llamada 1:1 con Chale  ·  Desktop: ● Agenda abierta · [teléfono] Llamada 1:1 con Chale
export function LiveHeader() {
  return <header className="bg-brand" data-id="element-597" data-mp="6g3w72hrq0m8">
      <div className="py-3 sm:py-4 flex items-center justify-center gap-2.5 sm:gap-3 px-4 text-white" data-id="element-598" data-mp="6hf3hcaf9qi3">
        <span className="relative flex h-2.5 w-2.5 shrink-0" aria-hidden="true" data-id="element-599" data-mp="u79cfirmeux2">
          <span className="absolute inline-flex h-full w-full rounded-full bg-gold opacity-75 animate-ping motion-reduce:animate-none" data-id="element-600" data-mp="z36qfifevp6o" />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-gold" data-id="element-601" data-mp="pdx28dnouqnu" />
        </span>
        <span className="hidden sm:inline font-semibold text-[17px] text-gold" data-id="element-602" data-mp="1d414agl8aicq">Agenda abierta</span>
        <span className="hidden sm:inline text-white/40" aria-hidden="true" data-id="element-603" data-mp="1hu7qyaw6jssc">·</span>
        <PhoneCall className="w-5 h-5 sm:w-6 sm:h-6 shrink-0" strokeWidth={2} aria-hidden="true" data-id="element-604" data-mp="1hwamtbk0kg4z" />
        <span className="font-semibold text-[16px] sm:text-[19px] tracking-tight" data-id="element-605" data-mp="2k358vz6a8ttp">{HEADER_TITLE}</span>
        <span className="sr-only" data-id="element-606" data-mp="2sxt8p9t39jb4">Agenda abierta</span>
      </div>
    </header>;
}